function percentToFraction(value, percentToFraction) {
  if (percentToFraction) {
    return value / 100;
  }
  return value * 100;
}

export default percentToFraction;
